<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Customers')"
          :description="$t('From here you can edit your customers details')"
          :showExport="'true'"
          :exportLink="path + '/export/excel'"
          :showImport="'true'"
          :explanationPath="path + '/explaination'"
        />
        <indexTable
          :searchText="$t('Search for a customer')"
          :emptyTableText="$t('There are no customers')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('customers_add')"
          :localData="true"
          :cloumns="[
            { column: 'id', title: $t('Code'), type: 'mainLink', sort: true },
            {
              column: 'name',
              title: $t('Customer name'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'tax_number',
              title: $t('Customer code'),
              type: 'text',
              sort: true
            },
            {
              column: 'mobile',
              title: $t('Phone number'),
              type: 'text',
              sort: true,
              icon: 'phone'
            },
            {
              column: 'balance',
              title: $t('Balance'),
              type: 'text',
              sort: true,
              icon: 'usd-square'
            },
            {
              column: 'stat',
              title: $t('Active'),
              type: 'stat',
              sort: true,
              hideMobile: true
            },
            {
              column: 'options',
              title: $t('Actions'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('customers_edit')
                },
                {
                  name: 'link',
                  role: $checkRole('sales_payments_add'),
                  title: $t('Add payment'),
                  icon: 'dollar-sign',
                  link: '/salesPayments/create?customer_id='
                },
                {
                  name: 'link',
                  role: $checkRole('quotations_add'),
                  title: $t('Add quotation'),
                  icon: 'calculator',
                  link: '/quotations/create?customer_id='
                },
                {
                  name: 'link',
                  role: $checkRole('invoices_add'),
                  title: $t('Add sales bill'),
                  icon: 'file-invoice-dollar',
                  link: '/invoices/create?customer_id='
                },
                {
                  name: 'link',
                  role: $checkRole('orders_add'),
                  title: $t('Add order'),
                  icon: 'briefcase',
                  link: '/orders/create?customer_id='
                },
                {
                  name: 'delete',
                  role: $checkRole('customers_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t(
              'Are you really sure the Client is deleted, If you delete the customer all invoices and processes will be deleted'
            ),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
    <importForm v-if="importShow" />
  </div>
</template>

<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
import importForm from './components/importForm.vue'

export default {
  data() {
    return {
      path: '/customers',
      importShow: false
    }
  },
  methods: {
    importForm() {
      this.importShow = true
    }
  },
  components: {
    indexHeader,
    indexTable,
    importForm
  }
}
</script>
